import {
  IonToast, IonRouterOutlet, IonSplitPane, setupIonicReact,
} from '@ionic/react';
import {Route, Redirect, Switch} from "react-router-dom";
import React  from 'react';
import {Menu} from '../components/Menu';
import {Network} from "@capacitor/network";
import {AppState, AppUser} from "../models/app";
import {Device} from '@capacitor/device';
import fb from "../lib/firebase";
import Home from './Home/Home'
import Lojas from "./Lojas/Lojas";
import Loja from "./Lojas/Loja";
import Veterinarios from "./Veterinarios/Veterinarios";
import Veterinario from "./Veterinarios/Veterinario";
import Fazendas from "./Fazendas/Fazendas";
import Fazenda from "./Fazendas/Fazenda";
import Eventos from "./Eventos/Eventos";
import Evento from "./Eventos/Evento";
import Anexo from "./Anexos/Anexo";
import Cadastro from "./Cadastro/Cadastro";
import Login from "./Login/Login";
import Agenda from "./Agenda/Agenda";
import {AppDispatch, RootState} from "../global.state";
import {connect} from "react-redux";
import {actions, resetLocalStorage} from "../lib/app";
import {fbUseEmulator, frBaseUrl, debugMode, fbEmulatorHost, fbEmulatorPort, debug} from "../config";
import { SplashScreen } from "@capacitor/splash-screen";
import {disableDeviceToken, enablePushNotifications, updateDeviceToken} from "../lib/pushService";
import Proprietarios from "./Proprietarios/Proprietarios";
import Proprietario from "./Proprietarios/Proprietario";
import localForage from "localforage";
import Sobre from './Privacidade/Sobre';
import TransferenciasPage from './Transferencias/TransferenciasPage';


interface Props {
  history: any;
  app: AppState;
  dispatch: AppDispatch;
}

interface State {
  restaurandoSessao: boolean;
  profileIsLoading: boolean;
}

setupIonicReact();
type cancelFunction = () => void;

class _App extends React.Component<Props, State> {
  private cancelListeners: cancelFunction[];
  private cacheListeners: cancelFunction[];
  private pushListeners: cancelFunction[];

  constructor(props:Props) {
    super(props);

    this.state = {
      restaurandoSessao: true,
      profileIsLoading: false,
    };
    this.cancelListeners = [];
    this.cacheListeners = [];
    this.pushListeners = [];
  }

  componentWillUnmount() {
    // console.log('== App unmount ==');
    this.disableListeners();
    this.cancelListeners.forEach(i => i());
    this.pushListeners.forEach(i => i());
  }

  disableListeners() {
    // console.log('== disableListeners ==');
    this.cacheListeners.forEach(i => i());
  }

  async componentDidMount() {
    await SplashScreen.hide();
    console.log('== App start ==');
    console.log(`  debugMode: ${debugMode}`);
    console.log(`  frBaseUrl: ${frBaseUrl}`);
    console.log(`  fbUseEmulator: ${fbUseEmulator}`);
    if (fbUseEmulator) {
      console.log(`  fbEmulatorHost: ${fbEmulatorHost}:${fbEmulatorPort}`);
    }

    this.initializePlugins().then(() => {
      debug('== DEBUG: Plugins initialized ==');
    });
    enablePushNotifications(this.pushListeners).then((pushEnabled) => {
      debug(`== DEBUG: Push notifications status: ${pushEnabled}`);
    });

    // Acesso offline
    if (!debugMode) {
      fb.db.enablePersistence()
        .then(() => {
          debug('== DEBUG: Offline persistence: enabled');
        })
        .catch((err) => {
          if (err.code === 'failed-precondition') {
            console.warn('== DEBUG: Offline persistence: failed-precondition');
          } else if (err.code === 'unimplemented') {
            // The current browser does not support all of the
            // features required to enable persistence
            console.warn('== DEBUG: Offline persistence: unimplemented');
          }
        });
    }

    // authentication handler
    const removeAuthListener = fb.auth.onAuthStateChanged((user: any) => {
      if (user) {
        debug("Loading user profile...");

        this.loadProfile({
          uid: user.uid,
          email: user.providerData[0].email,
          hasProfile: false,
          profileComplete: false,
          loaded: false,
        });
      } else {
        this.setState({restaurandoSessao: false});
        this.disableListeners();
      }
    });

    this.cancelListeners.push(removeAuthListener);
  }

  componentDidUpdate(prevProps: Readonly<Props>, prevState: Readonly<State>, snapshot?: any) {
    if (this.props.app.reloadProfile && !this.state.restaurandoSessao && !this.state.profileIsLoading) {
      this.loadProfile({...this.props.app.user});
    }
  }

  /*
  Load chached tables in global state
  */
  listenCachedData() {
    if (!this.props.app.online) return;

    if (this.cacheListeners.length > 0)
      this.disableListeners();

    // produtos
    const cancelProdutos = fb.db.collection('produtos')
      .orderBy('label', 'asc')
      .onSnapshot(snap => {
        const col = fb.col(snap);
        // console.log('App: listenCachedData.setProdutos', col);
        this.props.dispatch(actions.setProdutos(col));
    });
    this.cacheListeners.push(cancelProdutos);
  }

  async initializePlugins() {
    const netHandler = await Network.addListener('networkStatusChange', (status) => {
      // console.log("Network status changed", status);
      // if (!this.props.app.online && status.connected) {
      //   debug('App.initializePlugins', 'reset cached data listeners');
      //   this.listenCachedData();
      // }

      this.props.dispatch(actions.setOnline(status.connected));
    });
    this.cancelListeners.push(netHandler.remove);

    // estado inicial da rede
    const res = await Network.getStatus();
    // console.log(res);
    this.props.dispatch(actions.setOnline(res.connected));

    // Device info
    const info = await Device.getInfo();
    // console.log(info);
    this.props.dispatch(actions.setDeviceInfo(info));
  }

  async loadProfile(user:AppUser) {
    try {
      await this.doLoadProfile(user);
    } catch (err) {
      console.error('App.loadProfile', err);
      this.props.dispatch(actions.reloadProfileDone());
      this.setState({profileIsLoading: false, restaurandoSessao: false});
      this.props.dispatch(actions.notifyError('Não foi possível carregar o perfil. Conecte-se à internet e tente novamente.'));
    }
  }

  async doLoadProfile(user:AppUser) {
    this.setState({profileIsLoading: true});

    // reset token Fazenda Rentavel
    await localForage.removeItem('frAccess');

    // cache de dados básicos para acesso offline
    if (this.props.app.online) {
      try {
        await fb.db.collection('eventos_tipos').get();
        await fb.db.collection('produtos').get();
      } catch (err) {
        console.warn('App.loadProfile: falha ao atualizar cache', err);
      }
      this.listenCachedData();
    }

    const userRef = fb.db.collection('users').doc(user.uid);
    let snap;
    try {
      snap = await userRef.get();
    } catch (err) {
      // offline sem o doc no cache "padrão": tenta explicitamente o cache persistido
      snap = await userRef.get({source: 'cache'});
    }

    this.props.dispatch(actions.reloadProfileDone());
    this.setState({profileIsLoading: false});
    const profile = fb.doc(snap);
    user.loaded = true;
    if (profile) {
      // sem await: offline a promise de escrita só resolve quando o servidor confirmar
      userRef.update({
        'ultimo_acesso': fb.firebase.firestore.FieldValue.serverTimestamp(),
      }).catch((err) => console.warn('App.loadProfile: ultimo_acesso', err));

      // exigir regional se nao preenchido
      const {regional} = profile;
      if (!regional) {
        // atualizar state
        this.props.dispatch(actions.login({
          ...user,
          ...profile,
          hasProfile: true,
          profileComplete: false,
        }));

        await updateDeviceToken();

        // abrir cadastro
        this.setState({restaurandoSessao: false}, () => {
          this.props.history.replace('/cadastro');
        });
      } else {
        // atualizar state
        this.props.dispatch(actions.login({
          ...user,
          ...profile,
          hasProfile: true,
          profileComplete: true,
        }));

        await updateDeviceToken();

        // liberar acesso
        this.setState({restaurandoSessao: false}, () => {
          this.props.history.replace('/home');
        });
      }
    } else {
      // atualizar state
      this.props.dispatch(actions.login(user));

      // abrir cadastro
      this.setState({restaurandoSessao: false}, () => {
        this.props.history.replace('/cadastro');
      });
    }
  }

  onExit = () => {
    (async () => {
      // remover acesso Fazenda Rentável
      await disableDeviceToken();
      await resetLocalStorage();

      this.props.dispatch(actions.logout());
      // console.log('App: fb.auth.signOut');
      await fb.auth.signOut();
      this.disableListeners();
      // console.log('App: fb.auth.signOut DONE');
    })();
  };

  onClickMenu = (path: string) => {
    this.props.history.push(`/${path}`);
  };


  render() {
    const {notification} = this.props.app;

    return (
      <>
        <IonToast
          isOpen={this.state.restaurandoSessao}
          message="Carregando dados do aplicativo..."
          duration={0}
          color="dark"
        />
        <IonToast
          isOpen={notification.visible}
          message={notification.message}
          duration={notification.duration}
          color={notification.color}
          onDidDismiss={() => {
            this.props.dispatch(actions.notifyDismiss());
          }}
        />

        <Switch>
          <Route exact path="/login">
            <Login/>
          </Route>

          <Route exact path="/sobre">
            <Sobre />
          </Route>

          {!this.state.restaurandoSessao && !this.props.app.loggedIn &&
            <Route path="/">
              <Redirect to="/login"/>
            </Route>
          }
          {!this.state.restaurandoSessao && this.props.app.loggedIn &&
            <>
              <Route
                exact
                path="/"
                render={() => {
                  if (!this.props.app.user.hasProfile || !this.props.app.user.profileComplete)
                    return <Redirect to="/cadastro"/>;
                  else
                    return <Redirect to="/home"/>
                }}/>
              <IonSplitPane contentId="main">
                <Menu
                  user={this.props.app.user}
                  onClickExit={this.onExit}
                  onClick={this.onClickMenu}
                />
                <IonRouterOutlet id="main">

                  <Route exact path="/home" component={Home}/>
                  <Route exact path="/cadastro" component={Cadastro}/>

                  <Route exact path="/lojas" component={Lojas}/>
                  <Route path="/lojas/:instanceId" component={Loja}/>

                  <Route exact path="/veterinarios" component={Veterinarios}/>
                  <Route path="/veterinarios/:instanceId" component={Veterinario}/>

                  <Route exact path="/fazendas" component={Fazendas}/>
                  <Route path="/fazendas/:instanceId" component={Fazenda}/>

                  <Route exact path="/eventos" component={Eventos}/>
                  <Route path="/eventos/:instanceId" component={Evento}/>

                  <Route exact path="/proprietarios" component={Proprietarios}/>
                  <Route path="/proprietarios/:instanceId" component={Proprietario}/>

                  <Route path="/anexos/:instanceId" component={Anexo}/>

                  <Route exact path="/agenda" component={Agenda}/>

                  <Route exact path="/transferencias" component={TransferenciasPage}/>
                </IonRouterOutlet>
              </IonSplitPane>
            </>
          }
        </Switch>
      </>
    );
  }
}

export default connect(({app}: RootState) => ({app}))(_App);
